export const Bio = {
  name: "John Ekunola",
  fullName: "John Oluwatosin Ekunola",
  alternateName: "John Ekunola",
  jobTitle: "Frontend Developer",
  roles: ["Frontend Developer", "Frontend Engineer", "UI Engineer"],
  description:
    "Results-driven Frontend Developer with expertise in building modern, responsive, and high-performance web applications using React.js, Next.js, TypeScript, JavaScript, HTML, CSS, and Tailwind CSS. I transform complex design requirements into seamless user experiences while maintaining accessibility, scalability, and code quality standards.",
  github: "https://github.com/Jizzyjay",
  resume: "/john-oluwatosin-ekunola-resume.pdf",
  linkedin: "https://www.linkedin.com/in/ekunolajohn/",
  mail: "mailto:ekunolajohn@gmail.com",
  /** Canonical live portfolio (Vercel). */
  siteUrl: "https://new-portfolio-ochre-eight.vercel.app",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "HTML5", image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png" },
      { name: "CSS3", image: "https://upload.wikimedia.org/wikipedia/commons/6/62/CSS3_logo.svg" },
      { name: "JavaScript", image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
      { name: "TypeScript", image: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg" },
      { name: "React", image: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
      { name: "Next.js", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" },
      { name: "Angular", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" },
      { name: "RxJS", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rxjs/rxjs-original.svg" },
      { name: "NgRx", image: "https://avatars.githubusercontent.com/u/16628486?s=200&v=4" },
      { name: "Redux", image: "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg" },
      { name: "Solid.js", image: "https://www.solidjs.com/img/logo/without-wordmark/logo.png" },
      { name: "Tailwind CSS", image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
    ],
  },
  {
    title: "Tools & Workflow",
    skills: [
      { name: "GitHub", image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" },
      { name: "GitLab", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg" },
      { name: "Bitbucket", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bitbucket/bitbucket-original.svg" },
      { name: "Netlify", image: "https://www.netlify.com/v3/img/components/logomark.svg" },
      { name: "VS Code", image: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg" },
      { name: "Figma", image: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg" },
      { name: "Postman", image: "https://cdn.worldvectorlogo.com/logos/postman.svg" },
      { name: "Jira", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg" },
    ],
  },
  {
    title: "Backend & Data",
    skills: [
      { name: "Node.js", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
      { name: "Express", image: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png" },
      { name: "MongoDB", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg" },
      { name: "Firebase", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "",
    role: "Frontend Developer",
    company: "Bertandre Consulting",
    date: "Jan 2026 - Till Date",
    location: "Hybrid, Lagos",
    desc: "Collaborated with product, design, and backend teams to deliver responsive product experiences, maintain scalable frontend architecture, and improve application performance through better state management and reusable UI patterns.",
    skills: ["Next.js", "TypeScript", "Redux", "UI Engineering", "Figma"]
  },
  {
    id: 1,
    img: "",
    role: "Frontend Engineer",
    company: "MedFair",
    date: "Apr 2025 - Till Date",
    location: "Remote, Lagos",
    desc: "Converted Figma design mockups into responsive, pixel-perfect interfaces and maintained reusable component libraries to improve design consistency, performance, and delivery speed across the platform.",
    skills: ["Next.js", "TypeScript", "Design Systems", "Responsive UI", "Agile"]
  },
  {
    id: 2,
    img: "https://ventekk.com.ng/wp-content/uploads/2023/11/ventekk-logo.png",
    role: "Frontend Engineer",
    company: "Ventekk Inc.",
    date: "Apr 2024 - Sept 2025",
    location: "Remote, Lagos",
    desc: "Translated product requirements into responsive frontend components, improved UX, and helped ship an upgraded version of the company software with measurable performance and business impact.",
    skills: ["React", "Redux Toolkit", "TypeScript", "CSS Modules", "Testing"]
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dpuumfztf/image/upload/v1704307167/logo_pnysac.svg",
    role: "Frontend Developer",
    company: "Rentals",
    date: "Mar 2023 - Mar 2024",
    location: "Remote, Lagos",
    desc: "Focused on creating intuitive, visually appealing interfaces while improving frontend performance, responsiveness, and maintainability across a growing product experience.",
    skills: ["Solid.js", "TypeScript", "Redux Toolkit", "Styled Components", "UX"]
  },
  {
    id: 4,
    img: "https://reboost.live/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.db0dd3da.png&w=256&q=75",
    role: "Frontend Engineer",
    company: "Reboost",
    date: "Oct 2022 - Mar 2023",
    location: "Remote, London",
    desc: "Developed user-friendly web interfaces for business applications, collaborated closely with design and backend teams, and optimized performance to improve usability and delivery quality.",
    skills: ["React.js", "Next.js", "JavaScript", "CSS", "Optimization"]
  },
];

export const education = [
  {
    id: 0,
    img: "https://pbs.twimg.com/profile_images/1443562653331374080/RsFksmgg_400x400.jpg",
    school: "ALTSCHOOL AFRICA",
    date: "2022",
    degree: "Diploma, Software Engineering",
  },
  {
    id: 1,
    img: "https://jabu.edu.ng/wp-content/uploads/2019/07/JABU-Logo-n-Header.png",
    school: "JOSEPH AYO BABALOLA UNIVERSITY",
    date: "2013 - 2017",
    degree: "B.Sc Business Administration",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=200&q=80",
    school: "Zero to Mastery Academy",
    date: "Frontend Development",
    degree: "Frontend Development",
  },
];

export const projects = [
  {
    id: 1,
    title: "Chat app",
    description:
      "Realtime Chat App with MERN Stack. You can chat and search other users on the platform.",
    image:
      "https://res.cloudinary.com/dpuumfztf/image/upload/v1709642896/Untitled_2_ktng7f.jpg",
    tags: [
      "React",
      "Tailwind",
      "Typescript",
      "MongoDb",
      "Zustard",
      "Socket.io",
    ],
    // category: "web app",
    github: "https://github.com/Jizzyjay/chat",
    webapp: "https://chat-3kbt.onrender.com/",
  },
  {
    id: 2,
    title: "Threads-clone",
    description:
      "Threads Clone with with Next JS 13. Post threads and see what other users are up to.",
    image:
      "https://res.cloudinary.com/dpuumfztf/image/upload/v1707134693/Untitled_2_jk0gsb.jpg",
    tags: [
      "Next Js",
      "Tailwind",
      "Typescript",
      "MongoDb",
      "Clerk",
      "UploadThing",
    ],
    // category: "web app",
    github: "https://github.com/Jizzyjay/thread",
    webapp: "https://thread-sigma-orpin.vercel.app/",
  },
  {
    id: 3,
    title: "Github-clone",
    description:
      "This is a github-clone app, where you can like, clone a repository and also search for a github user.",
    image:
      "https://res.cloudinary.com/dpuumfztf/image/upload/v1711472808/Untitled_2_yqczhq.jpg",
    tags: [
      "Vite",
      "Tailwind",
      "Javascript",
      "MongoDb",
      "Passport",
      "github-oauth",
    ],
    // category: "web app",
    github: "https://github.com/Jizzyjay/git-clone",
    webapp: "https://git-clone-3mks.onrender.com/",
  },
  {
    id: 13,
    title: "CarePulse",
    description:
      "A healthcare patient management System designed to streamline patient registration, appointment scheduling, and medical records management for healthcare providers.",
    image:
      "https://res.cloudinary.com/dpuumfztf/image/upload/v1721125529/health_vmeaa4.jpg",
    tags: ["NextJs", "Typescript", "Tailwind", "Appwrite", "Twilio", "Sentry"],
    // category: "machine learning",
    github: "https://github.com/Jizzyjay/health-app",
    webapp: "https://health-app-gamma-six.vercel.app/",
  },
  {
    id: 5,
    title: "Figma-clone",
    description:
      "Figma clone with features like live collaboration through cursor chat, comments, reactions, and drawing designs.",
    image:
      "https://res.cloudinary.com/dpuumfztf/image/upload/v1707808209/Untitled_2_f14nju.jpg",
    tags: ["NextJs", "Typescript", "Tailwind", "Fabricjs", "Liveblocks"],
    category: "web app",
    github: "https://github.com/Jizzyjay/figma-clone",
    webapp: "https://figma-clone-opal.vercel.app/",
  },
  {
    id: 4,
    title: "Gallery",
    description: "Upload your pictures in the gallery.",
    image:
      "https://res.cloudinary.com/dpuumfztf/image/upload/v1704280998/gallery_zduvuf.jpg",
    tags: ["NextJs", "Typescript", "Tailwind"],
    category: "web app",
    github: "https://github.com/Jizzyjay/Gallery",
    webapp: "https://gallery-ten-indol.vercel.app/",
  },
];

export const websiteDesigns = [
  {
    id: 1,
    title: "AURA Sanctuaries",
    description:
      "A luxury travel and hospitality landing experience for private sanctuaries and bespoke journeys — quiet typography, destination storytelling, and high-end estate showcases across Kyoto, Amalfi, and beyond.",
    image: "/designs/aura-sanctuaries.jpg",
    tags: ["Luxury", "Travel", "Landing Page"],
    webapp: "https://aura-cyan-tau.vercel.app/",
  },
  {
    id: 2,
    title: "Brasa",
    description:
      "A Lagos food-delivery brand site built around cravings and speed — menu categories, tonight’s favorites, and a clear kitchen-to-doorstep flow for burgers, pasta, rice, and more.",
    image: "/designs/brasa.jpg",
    tags: ["Food Delivery", "E-commerce", "Brand Site"],
    webapp: "https://brasa-phi.vercel.app/",
  },
  {
    id: 3,
    title: "Primquisite Real Estate",
    description:
      "A Lagos property developer and agency site covering premium developments, PropTech estate systems, and project portfolios like Arabella, Crescendo, and Nacre.",
    image: "/designs/primquisite.jpg",
    tags: ["Real Estate", "PropTech", "Corporate"],
    webapp: "https://www.primquisiterealestate.com/",
  },
  {
    id: 4,
    title: "Dispatch News",
    description:
      "A broadsheet-style global news platform powered by NewsAPI — live wire feeds, desk categories, and editorial layouts for world, business, tech, and politics headlines.",
    image: "/designs/dispatch-news.jpg",
    tags: ["News", "Dashboard", "API"],
    webapp: "https://news-kappa-lyart.vercel.app/",
  },
  {
    id: 5,
    title: "Butcha",
    description:
      "A premium butcher brand site focused on cut-to-order meats and pickup convenience — featured products, shop locations, and a clear order-online-to-in-store flow.",
    image: "/designs/butcha.jpg",
    tags: ["E-commerce", "Food", "Brand Site"],
    webapp: "https://butcha.vercel.app/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
